var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"project-page"},[_c('h1',{staticClass:"project-page__title"}),_vm._l((_vm.projects),function(project,index){return _c('ProjectItem',{key:index,attrs:{"name":project.name,"description":project.description,"image":project.image,"videoOptions":project.videoOptions,"slug":project.slug}})})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }